export const chrome = {
  en: {
    fastShipping: "Fast Shipping",
    hassleFreeReturns: "60-Day Hassle-Free Returns",
    freeExchanges: "Free Exchanges",
    help: "Help",
    orderStatus: "Order status",
    // {n} = item count.
    cartItemsAria: "Cart, {n} items",
    // Shown only when JavaScript is disabled (SSR <noscript> banner).
    noScript:
      "JavaScript is required for the full BÆRSkin Tactical store experience. Please enable it to shop and check out.",
    seeMore: "See more",
    // alt text on the trust-badge / secure-order image strip.
    trustBadgeAlt: "Secure Order, 100% Quality, 100% Premium, Free Shipping",
    // Fallback alt for UGC gallery photos when the CMS omits image.alt.
    ugcImageAlt: "BÆRSkin customer wearing tactical gear",
    // Global header cart-button aria-label prefix (default when none passed).
    shoppingCart: "Shopping cart",
    // Mega-menu chrome. {name} = top-level menu item name.
    seeAllProductsIn: "See all products in {name}",
    navigationOf: "{name} navigation",
    // Fallback store header (apps/store constants/header.ts), only rendered
    // when the CMS omits channelHeader. CMS-provided header copy is operator
    // content and stays unlocalized; these are the built-in fallbacks.
    fallbackLogoAlt: "Return to BÆRSkin Tactical homepage",
    // Top-bar promo. %%CURRENCY%% / %%FREE_SHIPPING_THRESHOLD%% are literal
    // placeholders substituted by <TopPromoBanner> at render, kept verbatim.
    fallbackTopbarPromo:
      "60% OFF + FREE DELIVERY OVER %%CURRENCY%%%%FREE_SHIPPING_THRESHOLD%%",
    // Main-nav item labels.
    fallbackNavOffers: "Offers",
    fallbackNavBestSellers: "Best Sellers",
    // Veterans-charities static page image alts (bodies already localized).
    theFallenOutdoorsAlt: "The Fallen Outdoors Logo",
    hopeForTheWarriorsAlt: "Hope For The Warriors Logo",
    veteransInActionAlt: "Veterans in Action",
    // Veterans-charities ROUTE page image alts (distinct copy from the modal
    // component; kept as separate keys to preserve EN verbatim).
    veteransHeroImageAlt: "Hero Image - Veterans Charities",
    veteransSupportingOurHeroesAlt: "Supporting Our Heroes",
    veteransCharitiesStripAlt: "Veterans Charities Strip",
  },
  de: {
    fastShipping: "Schneller Versand",
    hassleFreeReturns: "60 Tage problemlose Rückgabe",
    freeExchanges: "Kostenloser Umtausch",
    help: "Hilfe",
    orderStatus: "Bestellstatus",
    cartItemsAria: "Warenkorb, {n} Artikel",
    noScript:
      "JavaScript ist für das vollständige BÆRSkin Tactical Store-Erlebnis erforderlich. Bitte aktiviere es, um einzukaufen und zur Kasse zu gehen.",
    seeMore: "Mehr anzeigen",
    trustBadgeAlt:
      "Sichere Bestellung, 100 % Qualität, 100 % Premium, kostenloser Versand",
    ugcImageAlt: "BÆRSkin Kunde in taktischer Ausrüstung",
    shoppingCart: "Warenkorb",
    seeAllProductsIn: "Alle Produkte in {name} ansehen",
    navigationOf: "{name} Navigation",
    fallbackLogoAlt: "Zurück zur BÆRSkin Tactical Startseite",
    fallbackTopbarPromo:
      "60% RABATT + GRATIS LIEFERUNG AB %%CURRENCY%%%%FREE_SHIPPING_THRESHOLD%%",
    fallbackNavOffers: "Angebote",
    fallbackNavBestSellers: "Bestseller",
    // Proper names of the charity organisations stay untranslated; only the
    // trailing "Logo" descriptor is localized.
    theFallenOutdoorsAlt: "The Fallen Outdoors Logo",
    hopeForTheWarriorsAlt: "Hope For The Warriors Logo",
    veteransInActionAlt: "Veterans in Action",
    veteransHeroImageAlt: "Titelbild – Veteranenhilfswerke",
    veteransSupportingOurHeroesAlt: "Unterstützung für unsere Helden",
    veteransCharitiesStripAlt: "Veteranenhilfswerke-Leiste",
  },
} as const
